import clsx from 'clsx'
import { FC, memo } from 'react'

import Accordeon from 'components/parts/accordeon/accordeon'

import { IAccordeonCardioData } from './data'

import styles from './accordeon-course-wrapper.module.scss'

interface IAccordeonCourseWrapper {
  accordeonData: IAccordeonCardioData
  modificator?: string
}

const AccordeonCourseWrapper: FC<IAccordeonCourseWrapper> = ({ accordeonData, modificator }) => {
  const { title, data } = accordeonData

  return (
    <div className={clsx(styles.container, { [modificator as string]: modificator })}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.wrap}>
        {data.map((el) => (
          <Accordeon {...el} key={el.key} isWhite />
        ))}
      </div>
    </div>
  )
}

export default memo(AccordeonCourseWrapper)
